<template>
  <section class="address-section container">
    <div class="container-inner">
      <h2 class="address-section__title">{{ title}}</h2>

      <div class="address-section__list">
        <div class="address-section__item"
             v-for="item in addresses"
             :key="item.id"
        >
          <div class="address-section__item-country">
            <span class="address-section__item-country-ico"
                  :style="`background-image: url(${item.image || item.icon})`"
            ></span>
            <span>{{ item.city || item.country }}</span>
          </div>
          <div v-if="item.address"
               class="address-section__item-row">{{ item.address }}</div>
          <div v-if="item.phone"
               class="address-section__item-row">
            <a :href="item.phone | toLinkPhone">{{ formatPhone(item.phone) }}</a>
          </div>
          <div v-if="item.email"
               class="address-section__item-row">
            <a :href="`mailto:${item.email}`">{{ item.email }}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PhoneNumber from 'awesome-phonenumber'

  export default {
    name: 'AddressSection',
    props: {
      title: String,
      addresses: Array
    },
    data() {
      return {

      }
    },
    methods: {
      formatPhone(number) {
        const pn = new PhoneNumber(number);

        return pn.getNumber('international') || number
      },
    }
  }
</script>

<style lang="less">

</style>
